import { navLinks } from '@/mocks/chiguaHomeData';

export default function Footer() {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer id="footer" className="bg-foreground-900 text-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <a href="#hero" onClick={(e) => handleClick(e, '#hero')} className="flex items-center gap-2 mb-4 no-underline">
              <div className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-chat-smile-2-line text-background-50"></i>
              </div>
              <span className="text-lg font-heading font-bold text-background-50 whitespace-nowrap">吃瓜在线</span>
            </a>
            <p className="text-sm text-background-50/60 leading-relaxed mb-4">
              吃瓜在线是国内领先的51国产吃瓜在线今日吃瓜内容聚合平台，提供今日吃瓜爆料最新视频和51吃瓜视频在线观看服务，日均更新超2000条娱乐八卦资讯，累计服务超5000万吃瓜群众。最新吃瓜在线，尽在吃瓜在线。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-heading font-bold text-background-50 mb-4">快速导航</h4>
            <ul className="space-y-2.5">
              {navLinks.map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    onClick={(e) => handleClick(e, link.href)}
                    className="text-sm text-background-50/60 hover:text-background-50 transition-colors cursor-pointer no-underline"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-heading font-bold text-background-50 mb-4">内容分类</h4>
            <ul className="space-y-2.5">
              <li><a href="#cards" onClick={(e) => handleClick(e, '#cards')} className="text-sm text-background-50/60 hover:text-background-50 transition-colors cursor-pointer no-underline">明星八卦</a></li>
              <li><a href="#cards" onClick={(e) => handleClick(e, '#cards')} className="text-sm text-background-50/60 hover:text-background-50 transition-colors cursor-pointer no-underline">网红动态</a></li>
              <li><a href="#cards" onClick={(e) => handleClick(e, '#cards')} className="text-sm text-background-50/60 hover:text-background-50 transition-colors cursor-pointer no-underline">综艺影视</a></li>
              <li><a href="#cards" onClick={(e) => handleClick(e, '#cards')} className="text-sm text-background-50/60 hover:text-background-50 transition-colors cursor-pointer no-underline">今日吃瓜爆料</a></li>
              <li><a href="#cards" onClick={(e) => handleClick(e, '#cards')} className="text-sm text-background-50/60 hover:text-background-50 transition-colors cursor-pointer no-underline">吃瓜视频在线</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-heading font-bold text-background-50 mb-4">合作伙伴</h4>
            <p className="text-sm text-background-50/60 leading-relaxed">
              更多合作伙伴即将入驻，敬请期待。
            </p>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-background-50/10">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-background-50/40">
              &copy; {new Date().getFullYear()} 吃瓜在线 — 你的娱乐八卦第一站。本站内容仅供娱乐参考。
            </p>
            <div className="flex items-center gap-4 text-xs text-background-50/40">
              <span>隐私政策</span>
              <span>用户协议</span>
              <span>免责声明</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}